import {Component, Input, OnInit} from '@angular/core';
import {VnaPortalService} from '../../../../service/vna-portal.service';
import {MessagingService} from '../../../../service/messaging.service';
import {VnaPortalSelected} from '../../../../data/messaging/VnaPortalSelected';
import {AuthService} from '../../../../service/auth.service';
import {LocalStorageService} from 'ngx-webstorage';
import {VnaPortalAppSelected} from '../../../../data/messaging/VnaPortalAppSelected';


@Component({
  selector: 'app-select-vna-portal',
    template: `
        <div class="form-group row" style="margin-bottom:0 !important;" >
            <label class="col-1 col-form-label">Portal</label>
            <div class="col-10">
                <ngx-select [items]="portals" [(ngModel)]="portal" [optionValueField]="valueField" [optionTextField]="textField" (select)="selected($event)" [disabled]="disabled" >
                    <ng-template ngx-select-option ngx-select-option-selected let-option let-text="text">
                        <img src="assets/img/flags/{{ option.data.portal | lowercase}}.png" />&nbsp;
                        <!--<i class="flag-icon flag-icon-{{ option.data.portal | lowercase}} h1" title="{{ option.data.portal | lowercase}}" id="{{ option.data.portal | lowercase}}"></i>-->
                        {{option.data.portal_name}} ({{option.data.portal}})
                    </ng-template>
                </ngx-select>
            </div>
        </div>
      `,
  styleUrls: ['./select-vna-portal.component.scss']
})
export class SelectVnaPortalComponent implements OnInit {

    @Input() valueField = 'pk';
    @Input() textField = 'portal';

    portals: Array<Object>;
    portal: any;
    disabled: boolean = true;

    private portalDefault: string;

    constructor(private portalHandler: VnaPortalService, private messaging: MessagingService, private auth: AuthService) {
        this.portals = [];
    }

    ngOnInit() {
        this.portalDefault = this.auth.getPortalDefault();
        let allowedPortals = this.auth.getAllowedPortals();

        this.portalHandler.getPortals().subscribe(
          result => {
              result.forEach( (portal: Object) => {
                  let idx = allowedPortals.findIndex( (o) => {
                      return (o['portal'] == portal['portal'] && o['app'] != 'Dev');
                  });

                  if(idx >= 0){
                      this.portals.push(portal);
                      if(portal['portal'] === this.portalDefault){
                          this.portal = portal[this.valueField];
                          this.messaging.sendMessage(new VnaPortalSelected(this.portal, portal['portal'], true));
                      }
                  }
              });

              this.disabled = false;
            }
        );

        this.messaging.message.subscribe(
            (result) => {
                if(result instanceof VnaPortalAppSelected){
                    let idx = this.portals.findIndex( (obj) => {
                        return obj['portal'] == result.getPortal();
                    });

                    if(idx >= 0){
                        this.portal = this.portals[idx][this.valueField];
                        this.messaging.sendMessage(new VnaPortalSelected(this.portal, result.getPortal(), false));
                    }
                }
            }
        )
    }

    private selected(value: any) {
        let currentPortal = this.portals.find((obj) => {
            return obj['pk'] === value;
        });

        this.messaging.sendMessage(new VnaPortalSelected(value, currentPortal['portal'], false));
    }


    private refreshValue(value: any) {
        this.portals = value;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/components/portal/selector/vna/select-vna-portal.component.ts